import {
  Add as AddIcon,
  DeleteOutline as DeleteOutlinedIcon,
  DragHandle as DragIcon,
} from '@mui/icons-material';
import { Button } from '@mui/material';
import { groupBy, set, toNumber, values } from 'lodash';
import { get } from 'lodash';
import { SidebarAccordion } from 'src/components/accordion';
import { IGcfProductListGroup } from 'src/interfaces';
import { lang, moveArrayItem } from 'src/utils';

import { MultipleCategoriesProducts } from '../multipleCategoriesProducts';
import { ColumnListProps } from './ColumnList.interface';

export const ColumnList = (props: ColumnListProps) => {
  const allGroups = values(props.groups);
  const initialGroupedCategories = groupBy(props.groups, (col) =>
    get(col, 'config.columnOrder', 1),
  );
  const [maxGroupOrder, maxColumnOrder] = allGroups.reduce(
    ([maxGroup, maxColumn], group) => [
      Math.max(maxGroup, group.order || 0),
      Math.max(maxColumn, group?.config?.columnOrder || 0),
    ],
    [0, 0],
  );

  const handleSortEnd = (oldIndex: number, newIndex: number) => {
    const originalColumnOrders = Object.keys(initialGroupedCategories).map(
      toNumber,
    );
    const categoriesArray = Object.values(initialGroupedCategories);
    const reorderedGroups = moveArrayItem(categoriesArray, oldIndex, newIndex);

    reorderedGroups.forEach((groups, columnIndex) => {
      groups.forEach((group) => {
        set(group, 'config.columnOrder', originalColumnOrders[columnIndex]);
      });
    });

    props.handleGroupChange('update', true)(reorderedGroups.flat());
  };

  const handleColumnAdd = () => {
    const newGroup: IGcfProductListGroup = {
      order: maxGroupOrder + 1,
      backups: {},
      products: {},
      config: {
        columnOrder: maxColumnOrder + 1,
      },
    };

    props.handleGroupChange('add')(newGroup);
  };

  const columnItems = Object.entries(initialGroupedCategories).map(
    ([columnOrder, groups], index) => {
      const columnLabel = `Column ${index + 1}`;

      return {
        label: columnLabel,
        content: (
          <MultipleCategoriesProducts
            groups={groups}
            maxGroupOrder={maxGroupOrder}
            showComponents={props.showComponents}
            componentType={props.componentType}
            productCategoryIDs={props.productCategoryIDs}
            themeId={props.themeId}
            handleGroupChange={props.handleGroupChange}
            componentConfig={props?.componentConfig}
          />
        ),
        hasError: false,
        dragIcon: <DragIcon />,
        deleteIcon: props.showComponents.showRemoveColumnButton &&
          Object.keys(initialGroupedCategories).length > 1 && (
            <DeleteOutlinedIcon
              color="error"
              onClick={(event) => {
                event.stopPropagation();
                props.handleGroupChange('delete')(groups);
              }}
            />
          ),
        columnId: columnOrder,
      };
    },
  );

  return props.showComponents.enableColumnList ? (
    <>
      <SidebarAccordion
        items={columnItems}
        onSortEnd={handleSortEnd}
        enableDnd={props.showComponents.enableColumnList}
      />

      {props.showComponents.showAddGroupButton && (
        <Button
          variant="text"
          startIcon={<AddIcon />}
          onClick={handleColumnAdd}>
          {lang.addAdditionalColumn}
        </Button>
      )}
    </>
  ) : (
    <MultipleCategoriesProducts
      groups={allGroups}
      maxGroupOrder={maxGroupOrder}
      showComponents={props.showComponents}
      componentType={props.componentType}
      productCategoryIDs={props.productCategoryIDs}
      themeId={props.themeId}
      handleGroupChange={props.handleGroupChange}
      componentConfig={props?.componentConfig}
    />
  );
};
